<template>
    <div class="home">
        <div class="header"></div>
        <van-tabs @click="onClick" color="#025DF4">
            <van-tab title="组织分类"></van-tab>
            <van-tab title="民非"></van-tab>
            <van-tab title="社团"></van-tab>
        </van-tabs>
        <div class="list">
            <div class="item" v-for="(item,index) in list" :key="index" @click="go(item)">
                <img class="img" :src="item.logo" >
                <div>{{item.name}}</div>
                <img class="icon" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230818/1692347426/133639.png" >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
       return {
        type: 0,
        list: []
       } 
    },
    methods: {
        onClick(name, title) {
            this.type = name
            this.getlist()
        },
        getlist() {
            this.$api.system.list({type: this.type}).then((res) => {
                if (res.code * 1 === 200) {
                    this.list = res.data
                    
                }
            })
        },
        go(item){
            window.location.href = item.weixinurl
        }
    },
    mounted() {
        console.log(111)
        this.getlist()
    }
}
</script>

<style lang="less" scoped>
.home{
    background: #F9F9F9;
    .header{
        background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20230818/1692347426/442033.png) no-repeat;
        width: 100%;
        height: 3.64rem;
        background-size: 100% 100%;
    }
    .list{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: .39rem .16rem;
        .item{
            background: #FFFFFF;
            box-shadow: 0px .1rem .24rem .11rem rgba(216,219,229,0.3);
            border-radius: .18rem;
            width: 2.32rem;
            height: 3.13rem;
            margin-bottom: .2rem;
            font-size: .26rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: .29rem .2rem .2rem;
            .img{
                width: 1.16rem;
                height: 1.16rem;
                background: #E6EFFE;
                border-radius: 50%;
            }
            .icon{
                width: .54rem;
                height: .54rem;
            }
        }
    }
}
</style>